import React from "react";
import {Link} from "react-router-dom";
import StatusBadge from "../components/StatusBadge";
import {formatPrice} from "../components/Fields";
import {mediaUrl} from "../components/media";

const ProjectsTab = ({projects, broker, approved}) => {
    const isBuilder = broker.accountType === "BUILDER";
    return (
        <div className="brk-card">
            <div className="brk-card__head">
                <p className="brk-card__lead">
                    A project groups its unit types (2 BHK, 3 BHK…) under one name, location, RERA number, amenities and
                    brochure. Each unit type appears in search on its own, with the project's details.
                </p>
                {approved && <Link className="brk-btn brk-btn--primary brk-btn--sm" to="/broker/projects/new">+ New project</Link>}
            </div>
            {projects.length === 0 ? (
                <p className="brk-empty">
                    {isBuilder ? "No projects yet. Create one to list its unit types." : "No projects. Agents marketing a builder's project can add it here too."}
                </p>
            ) : (
                <ul className="brk-project-cards">
                    {projects.map((p) => (
                        <li key={p.id} className="brk-project-card">
                            <Link to={`/broker/projects/${p.id}`} className="brk-project-card__cover">
                                {p.coverImageUrl ? <img src={mediaUrl(p.coverImageUrl)} alt="" loading="lazy"/> : <span aria-hidden="true">🏗️</span>}
                            </Link>
                            <div className="brk-project-card__body">
                                <div className="brk-item__top">
                                    <Link to={`/broker/projects/${p.id}`} className="brk-item__title">{p.name}</Link>
                                    <StatusBadge status={p.reviewStatus} pendingChanges={p.pendingChanges}/>
                                </div>
                                <p className="brk-item__meta">{[p.location, p.possessionStatus].filter(Boolean).join(" · ")}</p>
                                <p className="brk-item__meta">
                                    {p.units.length} unit type{p.units.length === 1 ? "" : "s"}
                                    {p.priceFrom ? ` · ${formatPrice(p.priceFrom)}${p.priceTo && p.priceTo !== p.priceFrom ? ` – ${formatPrice(p.priceTo)}` : ""}` : ""}
                                    {p.reviewStatus === "APPROVED" ? ` · ${p.liveUnits} live` : ""}
                                </p>
                                {p.reviewNote && ["CHANGES_REQUESTED", "REJECTED"].includes(p.reviewStatus) && (
                                    <p className="brk-item__note">Reviewer: {p.reviewNote}</p>
                                )}
                                <Link className="brk-link" to={`/broker/projects/${p.id}`}>Open project →</Link>
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default ProjectsTab;
